const CompanyMotto = () => {
  return <section id="motto" className="py-20 bg-background relative overflow-hidden">

      {/* Decorative Background Elements */}
      <div className="absolute inset-0 wire-pattern opacity-30"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-4xl text-steel-dark dark:text-white mb-8 font-semibold md:text-4xl">
            شعار ما:
            <span className="text-copper block mt-2 hidden">
              "قدرت در هر دور، کیفیت در هر سیم"
            </span>
          </h2>

          <p className="text-lg md:text-xl text-steel leading-relaxed text-justify">
            ما در شرکت کیا الکتروموتور، بیش از دو دهه است که با تکیه بر دانش فنی روز دنیا و
            استفاده از بهترین مواد اولیه، در زمینه تولید انواع الکترو موتورهای الکتریکی فعالیت می‌کنیم.
            هدف ما ارائه محصولاتی با بالاترین کیفیت و کارایی برای صنایع مختلف کشور است.
            تیم متخصص ما همواره در تلاش برای بهبود فرآیندهای تولید و ارائه خدمات پس از فروش بی‌نظیر می‌باشد.
          </p>

        </div>
      </div>
    </section>;
};
export default CompanyMotto;
